<template>
  <div class="CD-box">
    <div v-if="videoError" class="CD-box-video-err">
      <img src="../assets/img/liveError.png" alt="" />
    </div>
    <video :src="playPath" v-else class="CD-box-video" autoplay controls></video>
    <p class="CD-box-title">{{ params.passagewayName }}</p>
    <span class="CD-box-tag-error" v-if="videoError">无信号</span>
    <span class="CD-box-tag" v-else>直播中</span>
    <img src="../assets/img/CDboxwelcome.png" class="CD-box-welcome" />
  </div>
</template>

<script>
import * as api from "@/api/api";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      videoError: false,
      params: {
        passagewayName: "",
        passagewayType: "",
        passagewayState: "",
        hlsPlayPath: "",
        pullPath: "",
      },
    };
  },
  computed: {
    ...mapState(["inWX", "IOS"]),
    playsinline() {
      var ua = navigator.userAgent.toLocaleLowerCase();
      //x5内核
      if (ua.match(/tencenttraveler/) != null || ua.match(/qqbrowse/) != null) {
        return false;
      } else {
        //ios端
        return true;
      }
    },
    playPath() {
      if (this.params.passagewayType == 1) {
        //推流
        return this.params.hlsPlayPath;
      } else {
        //拉流
        return this.params.hlsPlayPath;
      }
    },
  },
  mounted() {
    console.log(this.$route.query.id);
    if (this.$route.query.id) {
      api
        .getChannelForId(this.$route.query.id)
        .then(({ data }) => {
          if (data.status == 0) {
            for (const key in this.params) {
              for (const key2 in data.data) {
                if (key == key2) {
                  this.params[key] = data.data[key2];
                }
              }
            }
            if (data.data.passagewayState == 3) {
              this.videoError = true;
            }
          }
        })
        .catch(() => {
          this.videoError = true;
        });
    } else {
      this.videoError = true;
    }
    this.getRem(750, 100);
    window.onresize = () => {
      this.getRem(750, 100);
    };
  },
  methods: {
    getRem(pwidth, prem) {
      let html = document.getElementsByTagName("html")[0];
      let oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      html.style.fontSize = (oWidth / pwidth) * prem + "px";
    },
  },
};
</script>

<style scoped>
.CD-box {
  overflow: hidden;
}
.CD-box .CD-box-video {
  width: 100%;
  background-color: #000;
  height: 5.1rem;
  display: block;
}
.CD-box .CD-box-video-err {
  width: 100%;
  background-color: #000;
  height: 5.1rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.CD-box .CD-box-video-err img {
  display: block;
  width: 1.4rem;
}
.CD-box .CD-box-title {
  padding: 0 0.3rem;
  box-sizing: border-box;
  width: 100%;
  color: #333;
  font-size: 0.36rem;
  height: 0.4rem;
  line-height: 0.4rem;
  margin-top: 0.3rem;
  margin-bottom: 0.2rem;
}
.CD-box .CD-box-tag {
  width: 0.87rem;
  height: 0.35rem;
  border-radius: 0.04rem;
  background-color: #df182b;
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.35rem;
  display: block;
  margin-left: 0.3rem;
}
.CD-box .CD-box-tag-error {
  width: 0.87rem;
  height: 0.35rem;
  border-radius: 0.04rem;
  background-color: #a3a4ac;
  color: #fff;
  font-size: 0.24rem;
  text-align: center;
  line-height: 0.35rem;
  display: block;
  margin-left: 0.3rem;
}
.CD-box .CD-box-welcome {
  display: block;
  width: 6rem;
  margin: 0 auto;
}
</style>
